import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../services';
import { PartnerPlan } from '../../enum';

export const IsBasicPartnerPlanGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.partner.partner_plan === PartnerPlan.Basic) {
    router.navigate(['ssp-dsp-dashboard']);

    return false;
  }

  return true;
};
